import { GxRadio } from '@garpix/garpix-web-components-react';
import cn from 'classnames';
import React, { FC } from 'react';
import styles from './styles/index.module.scss';

export interface IRadio {
  name: string;
  checked: boolean;
  setValue?: (name: string, target: boolean) => void;
  flag?: boolean;
  handleChange?: any;
  props?: any;
  onClick?: React.MouseEventHandler<HTMLGxRadioElement> | undefined;
  className?: any;
  disabled?: boolean;
  value?: any;
}

const Radio: FC<IRadio> = ({
  children,
  disabled,
  handleChange,
  onClick,
  className,
  value,
  ...props
}) => {

  const onClickButton: React.MouseEventHandler<HTMLGxRadioElement> = (e) =>{
    if (!disabled && onClick){
      onClick(e)
    }
  }

  return (
    <GxRadio
      className={cn(styles['radio'], { [className]: !!className })}
      onClick={onClickButton}
      onGx-change={handleChange}
      disabled={disabled}
      value={value}
      {...props}
    >
      {children}
    </GxRadio>
  );
};

export default Radio;
